import {NoResultsController} from './controllers/noResultsController';

import './styles/noResults.scss';
export class NoResultsDirective implements angular.IDirective {
    restrict = 'E';
    scope = {};
    controller = NoResultsController;
    controllerAs = 'vm';
    replace = true;
    bindToController = {
        items: '=',
        isLoading: '=',
        isGlobalSearchAllowed: '=',
        isSearchAllRequestsButtonVisible : '='
    };
    template = require('./templates/noResults.html');

    static factory(): angular.IDirectiveFactory {
        return () => new NoResultsDirective();
    }
}

angular.module('deliveryCreate.app')
    .directive('noResults', NoResultsDirective.factory());


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/noResults/noResultsDirective.ts
 **/